import { render } from "./EditCeibaDevice.vue?vue&type=template&id=147a96fb"
import script from "./EditCeibaDevice.vue?vue&type=script&lang=js"
export * from "./EditCeibaDevice.vue?vue&type=script&lang=js"
script.render = render

export default script